import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton-card',
  templateUrl: './skeleton-card.component.html',
  styleUrls: ['./skeleton-card.component.css']
})
export class SkeletonCardComponent {

  /** Üstte title çizgisi olsun mu */
  @Input() showTitle: boolean = true;

  /** Kaç satır skeleton line çizilecek */
  @Input() lineCount: number = 4;

  /** Alt tarafta badge benzeri yuvarlak alanlar olsun mu (ör: toplam bakiye, skorlar) */
  @Input() showBadges: boolean = false;

  /** Kart minimum yüksekliği (px) */
  @Input() minHeight: number = 220;

  get linesArray() {
    return Array(this.lineCount);
  }

  get badgesArray() {
    return Array(3); // istersen @Input yapabilirsin
  }
}
